/**
 * Convert a theme into a makeTheme
 * @param theme
 */
export const toMakeTheme = (theme) => (userTheme) => ({ ...theme, ...userTheme });

function makeThemeFromList(list, theme) {
  const all = [].concat(list);
  let t = theme;
  let mt;
  while (mt = all.pop()) { // eslint-disable-line
    t = mt(t);
  }
  return t;
}

/**
 * Create a makeTheme using a list of makeTheme
 * @param list
 * @returns {function(*=): *}
 */
export default function createMakeTheme(list) {
  return (theme) => makeThemeFromList(list, theme);
}
